/* ====================================================================
   BEHAVIOURS —> IMPORTS
   ==================================================================== */

/**
 * Import each behaviour here, the name given in the export statement
 * should match the value of the data-behaviour attribute stored within
 * the DOM
 */

// export {default as testBehaviour} from './_testBehaviour';

/**
 * Carousels
 */

export { default as flickitySlider } from './_flickitySlider';

/**
 * Mobile specific behaviours
 */

export { default as accordion } from './_accordion';
export { default as mobileMenu } from './_mobileMenu';
export { default as filterAccordion } from './_filterAccordion';
export { default as extractText } from './_extractText';
export { default as extractDescription} from './_extractDescription';
export { default as readMore } from './_readMore.js';
export { default as cartChecker } from './_cartChecker.js';
export { default as handleCartForm } from './_handleCartForm';
export { default as search } from './_search';
export { default as instagramFeed } from './_instagramFeed.js';
